module.exports = __webpack_public_path__ + "img/shuizhi.5c2b8cd6.png";